import json from './sprite.js';

export default {
    handle: 'SP_SPT9-Book',
    label: 'es_SPT9-Book_234684177',
    json,
};
